
import React, { useState } from 'react';
import ProTitle from '../../components/ProTitle';
import jiage1 from "../../static/images/jiage1.png"
import jiage2 from "../../static/images/jiage2.png"
import jiage3 from "../../static/images/jiage3.png"
import shichang1 from "../../static/images/shichang1.png"
import shichang2 from "../../static/images/shichang2.png"
import shichang3 from "../../static/images/shichang3.png"

export default function App() {
  const memo = '项目各投标供应商基础信息查询、关联关系查询'
  const memoa ='价格趋势与指数模块是采购成本管控的核心参考工具。它整合多源数据，按品类、周期构建价格指数，通过曲线呈现波动趋势并预判走势，同步触发价格预警，为把握采购时机、管控成本提供精准数据支撑'
  const memob='市场调研与分析模块是招采业务的 “数据决策中枢”，通过整合内外部招采市场数据、运用智能分析模型，解决传统人工调研数据零散、分析低效、结论滞后的问题，为采购需求规划、价格管控提供科学依据，帮助客户在招采决策中精准匹配市场动态，降低成本与风险'
  return (
    <>
    
    <div className='jiage' id="part-5">
      <ProTitle name={'价格趋势与指数'} memo={memoa} />
      <div>
        <ul>
          <li>
            <i><img src={jiage1} /></i>
            <h3>价格趋势智能研判</h3>
            <p>基于历史价格数据与实时市场动态，通过 AI 算法生成采购标的价格波动曲线，精准标记价格峰值、谷值及环比 / 同比变化率，可预测未来价格走势，预测过程综合考量商品数据，助力把握采购时机</p>
          </li>
          <li className='list'>
            <i><img src={jiage2} /></i>
            <h3>多维度价格对比分析</h3>
            <p>支持跨维度对比分析，可将当前价格与历史同期、市场均价、成本进行比对，自动计算价格差异；对比不同供应商同品类报价的历史走势，辅助评估供应商价格稳定性与性价比，为供应商谈判提供数据支撑</p>
          </li>
          <li>
            <i><img src={jiage3} /></i>
            <h3>趋势报告生成与追溯</h3>
            <p>支持生成价格趋势分析报告，包含曲线、指数变化、策略建议等内容，可直接用于内部汇报或决策参考。系统自动留存所有历史价格数据与分析报告，满足审计追溯要求，同时为年度预算编制提供精准的价格预测依据</p>
          </li>
        </ul>
      </div>
    </div>
    <div className='shichang' id="part-6">
      <ProTitle name={'市场调研与分析'} memo={memob} />
      <div>
        <ul>
          <li>
            <div className='titleicon'>
              <i><img src={shichang1} /></i>
              <h3>多源数据智能采集</h3>
            </div>
            <p>可实时抓取全国 / 区域公共资源交易平台、行业数据库的同类项目中标价、供应商信息、采购需求频次等数据，同时支持导入内部历史交易数据，形成覆盖 “供给 - 价格 - 竞争” 的完整数据库，无需人工逐一搜集整理，确保数据全面且实时更新</p>
          </li>
          <li className='list'>
            <div className='titleicon'>
              <i><img src={shichang2} /></i>
              <h3>需求匹配度分析</h3>
            </div>
            <p>将自身采购需求（如预算、规格、交付周期）与市场同类项目数据对比，分析需求的合理性（如预算是否高于 / 低于市场均价、规格是否符合行业主流），并提供需求优化建议（如调整参数以降低成本、扩大供应商选择范围），避免需求与市场脱节</p>
          </li>
          <li>
            <div className='titleicon'>
              <i><img src={shichang3} /></i>
              <h3>可视化报告自动生成</h3>
            </div>
            <p>支持一键生成多维度分析报告，报告包含数据图表（折线图、饼图、柱状图）、核心结论与决策建议，无需人工排版，可直接用于内部汇报或决策参考</p>
          </li>
        </ul>
      </div>
    </div>
    <div className='suppleBox' id="part-4">
      <ProTitle name={'投标供应商基础信息与关联关系查询（参考）'} memo={memo} />
      <div>
        <ul>
          <li>
            <h3>风险实时监控</h3>
            <p>从单位工商、司法涉诉、融资、财报、行政处罚、债权、上市公司披露信息、新闻舆情、单位关联信息、业务分析等角度构建全面的预警模型及指标，对单位进行实时监控，预警信号生成后，可查看预警规则详情、预警规则具体逻辑、对应的数据源以及原始数据等，进行追踪及溯源，对风险信号进行核查</p>
          </li>
          <li>
            <h3>智能风险分级预警</h3>
            <p>通过单位、个人、股东之间的多维度关系挖掘，有效快速的发现实体间的共同特征。风险监控信息包括：法定代表人、实际控制人、最终受益人、股东、高管、对外投资、控股、对外担保、分支机构、供应商、客户、历史对外投资、历史法定代表人等多维度信息。</p>
          </li>
          <li>
            <h3>多维度风险数据采集</h3>
            <p>汇集海量企业数据，一站式查询境内企业工商、幕后信息、上市公告、司法诉讼、经营信息、经营风险舆情资讯、知识产权、行业分析等多维综合信息，以及境外企业综合信息</p>
          </li>
          <li>
            <h3>风险报告生成与分析</h3>
            <p>通过高效的大数据处理流程，快速展示AI算法模型与数据集成能力。提供丰富的工具产品和算法服务，快速协助客户实现业务赋能</p>
          </li>
        </ul>
      </div>
    </div>
    </>
    
  );
}
